

/* open thirdparty url in new tab by FT */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("agree-terms");
  const addToCartButton = document.getElementById("add-to-cart-button");
  const buyNowButton = document.getElementById("buy-now-button");
  const termsPopup = document.getElementById("terms-popup");
  const closeTermsPopup = document.getElementById("close-terms-popup");
  const termsLink = document.getElementById("show-terms-popup");
  const closeTermsPopupIcon = document.getElementById("close-terms-popup-icon");
  const rxPopup = document.getElementById("rx-popup");
  const closeRxPopup = document.getElementById("close-rx-popup");

  // Get RX field value
  const requiresRx = addToCartButton?.getAttribute("data-rx-field") === "true";

  // Create overlay dynamically
  const overlay = document.createElement("div");
  overlay.classList.add("popup-overlay");
  document.body.appendChild(overlay);

  function disableButtons() {
    addToCartButton.disabled = true;
    addToCartButton.classList.add("disabled");
    if (buyNowButton) {
      buyNowButton.disabled = true;
      buyNowButton.classList.add("disabled");
    }
  }

  function enableButtons() {
    addToCartButton.disabled = false;
    addToCartButton.classList.remove("disabled");
    if (buyNowButton) {
      buyNowButton.disabled = false;
      buyNowButton.classList.remove("disabled");
    }
  }

  // Initially disable Add to Cart and Buy Now if Terms checkbox is present
  if (checkbox) disableButtons();

  function showPopup(popup) {
    popup.style.display = "block";
    overlay.style.display = "block";
    document.body.classList.add("no-scroll");
  }

  function closePopup(popup) {
    popup.style.display = "none";
    overlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  }

  // Show Terms popup (hover/click)
  if (termsLink) {
    termsLink.addEventListener("mouseover", () => showPopup(termsPopup));
    termsLink.addEventListener("click", (event) => {
      event.preventDefault();
      showPopup(termsPopup);
    });
  }

  // When Terms popup closes, if RX is also required, show RX popup next
  function handleCloseTermsPopup() {
    closePopup(termsPopup);
    if (checkbox) {
      checkbox.checked = true;
      enableButtons();
    }

    // If RX is required, open RX popup right after Terms
    if (requiresRx) {
      setTimeout(() => {
        showPopup(rxPopup);
      }, 300); // small delay for smooth transition
    }
  }

  if (closeTermsPopup) {
    closeTermsPopup.addEventListener("click", handleCloseTermsPopup);
  }

  if (closeTermsPopupIcon) {
    closeTermsPopupIcon.addEventListener("click", () => closePopup(termsPopup));
  }

  overlay.addEventListener("click", function () {
    closePopup(termsPopup);
    closePopup(rxPopup);
  });

  // Enable/Disable buttons based on Terms checkbox
  if (checkbox) {
    checkbox.addEventListener("change", function () {
      checkbox.checked ? enableButtons() : disableButtons();
    });
  }

  // Handle RX popup on Add to Cart click
  function handleRxPopup(event) {
    if (requiresRx) {
      event.preventDefault();

      // If Terms checkbox exists and unchecked, show Terms first
      if (checkbox && !checkbox.checked) {
        showPopup(termsPopup);
      } else {
        showPopup(rxPopup);
      }
    }
  }

  if (addToCartButton) {
    addToCartButton.addEventListener("click", handleRxPopup);
  }

  // Close RX popup
  if (closeRxPopup) {
    closeRxPopup.addEventListener("click", function () {
      closePopup(rxPopup);
    });
  }
});

//expiry


document.addEventListener('click', function(e) {
  const option = e.target.closest('.custom-select__option');
  if (option) {
    e.preventDefault();
    const value = option.getAttribute('data-value');
    if (value) {
      location.reload(); // refresh the page
    }
  }
});


/* collection page- instock filter selected by default */
 document.addEventListener('DOMContentLoaded', function() {
   if (!window.location.pathname.includes('/collections/')) return;

   const url = new URL(window.location.href);
  if (url.searchParams.has('filter.v.availability')) return;

  url.searchParams.set('filter.v.availability', '1');
  window.location.replace(url.toString());
});